enum FulfillmentPreferenceType {
  DELIVERY = "delivery",
  DELIVERY_DIGITAL = "delivery-digital",
  PICKUP = "pickup",
  NON_SHIPPABLE = "non-shippable",
  SHIP = "ship",
}

export default FulfillmentPreferenceType;
